var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.127 26.9345L36.5275 34.8194H16.464L12.7368 28.389H7.97864V12.6191H15.671L18.2086 8.33215H41.2063V26.9345H41.127Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8526 8.17893V4.58095H20.5084V1.36572H38.2721V4.58095H31.9279V8.17893M7.97861 22.9536H4.17209V29.0779H1V12.0066H4.17209V18.1308H8.13721L7.97861 22.9536ZM41.4442 22.9536H45.1714V29.0779H48.5814V12.0066H45.1714V18.1308H41.4442V22.9536Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHp);
export default __webpack_public_path__ + "static/media/hp.f2f399f75680f590effc092488746c69.svg";
export { ForwardRef as ReactComponent };